(function () {
  if (window.location.pathname !== '/search') return;

  const query = window.location.search.toLowerCase();

  const redirects = [
    {
      keywords: ['q=terna', 'q=ultrassom', 'q=ultrasom'],
      target: '/pages/terna-ultrassom-portatil-para-gestantes'
    }
  ];

  redirects.forEach(function (item) {
    item.keywords.forEach(function (keyword) {
      if (query.includes(keyword)) {
        window.location.replace(item.target);
      }
    });
  });
})();
